var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.order.call)?_c('div',{staticClass:"pr-3 text-right"},[(_vm.order.call.state !== 'ended')?_c('span',[_vm._v(" "+_vm._s(_vm.activeCallDuration)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.endedCallDuration)+" ")])]):_c('div',{staticClass:"pr-3 text-right"},[_vm._v(" --:--   ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }